
define('text!modules/admin/user/templates/layout.html',[],function () { return '<div class="grid"></div>\n';});

